import { getApv, postApv } from '../../apis';
import { decodeJWT, getIframe, setAddEventListener } from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { setAlertModal, showAlertModal } from '../components/alert';

const AccountArsAuth = {
  render: async () => {
    return `
      <div>
        <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">ARS 인증</div>
      <div class="form-group">
          <label class="c_label1">휴대폰번호</label>
          <input id="phone" type="text" class="form-control c_input1 skin1_input" value="${
            decodeJWT().ph
          }" placeholder="01023456789">
      </div>
      <div class="c_label5_1 m_t_40 m_b_40 text_center">
          등록된 휴대폰번호로 ARS 인증 전화를 요청합니다.<br />
          전화 수신 후에 안내 음성에 따라<br />
          생년월일 6자리를 입력해주세요.<br />
      </div>
      <div class="bottom_btn_wrapper">
          <button id="account_ars_auth_req_call" class="btn c_btn1 skin1_btn">ARS 전화 요청</button>
          <button id="account_ars_auth_check" class="btn c_btn1 skin1_btn" style="display: none">ARS 인증 확인</button>
      </div>
    `;
  },
  afterRender: async () => {
    // ARS 인증 성공 여부
    let arsSuccess = false;
    setAlertModal();

    // PIN 체크 -> 페이지 이동
    const checkPin = async () => {
      let existPin = true;
      try {
        await getApv('common/pinRegCheck');
      } catch (e) {
        existPin = false;
      } finally {
        // PIN 등록 상태 -> 계좌등록완료 이동
        if (existPin) {
          pushRouter(null, null, routes.accountRegiComplete.hashPath);
        }
        // PIN 미등록 -> PIN 등록 -> 계좌등록완료
        else {
          pushRouter(
            {
              mode: 'PIN_STEP_1',
              nextHash: routes.accountRegiComplete.hashPath,
            },
            null,
            routes.enterPwd.hashPath,
            () => {
              setDisableBackControl();
            }
          );
        }
      }
    };

    const reqArs = async () => {
      try {
        const state = history.state;

        // ARS인증 요청
        const arsCertData = {
          phone: getIframe().getElementById('phone').value.trim(),
          accEntyno: state.accEntyno,
        };
        const res = await postApv('common/ArsCertRec', arsCertData);
        if (res.arsSuccess == '9002') {
          arsSuccess = true;
          accountReg();
        }
      } catch (e) {
        switch (e.resultCode) {
          case 1001:
            showAlertModal('알림', e.resultMessage, () => {
              history.go(-2);
            });
            break;
          case 1002:
            await accountReg();
            break;
          default:
            showAlertModal('오류', e.resultMessage);
            console.error(e);
            break;
        }
      }
    };

    const accountReg = async () => {
      try {
        const accountRegData = {
          accEntyno: history.state.accEntyno,
        };
        await postApv('account/accountReg', accountRegData);

        // PIN 체크 -> 페이지 이동
        await checkPin();
      } catch (e) {
        showAlertModal('오류', e.resultMessage);
        console.error(e);
      }
    };

    setAddEventListener('account_ars_auth_req_call', async () => {
      getIframe().getElementById('account_ars_auth_req_call').style.display =
        'none';
      getIframe().getElementById('account_ars_auth_check').style.display =
        'block';
      await reqArs();
    });

    setAddEventListener('account_ars_auth_check', async () => {
      // ARS 인증 성공
      if (arsSuccess) {
        await accountReg();
      }
      // ARS 재요청 (인증실패, timeout)
      else {
        await reqArs();
      }
    });

    setAddEventListener('connect_pay_back_button', () => history.back());
  },
};
export default AccountArsAuth;
